import axiosInstance from "./service-instance";

export default {
    create: (case_id, statementRow) =>
        axiosInstance.post(`/company/${case_id}/banking-detail/`, statementRow),
    fetchStatement: (case_id, bank_account_id) =>
        axiosInstance.get(`/company/${case_id}/banking-detail/`, {
            params: {
                bank_account: bank_account_id,
                paginate: false
            }
        }),
    in_active_previous: (caseId, case_bank_account) =>
        axiosInstance.post("/company/banking-detail/in-active/", {
            case: caseId,
            case_bank_account
        }),
    updateStatement: (case_id, detail_id, statement) =>
        axiosInstance.put(
            `/company/${case_id}/banking-detail/${detail_id}/`,
            statement
                .toSeq()
                .toMap()
                .set(
                    "txn_month_year",
                    statement.txn_month_year.format("YYYY-MM-DD")
                )
        )
};
